import { render, staticRenderFns } from "./NewFile.vue?vue&type=template&id=7299799e&scoped=true"
import script from "./NewFile.vue?vue&type=script&lang=js"
export * from "./NewFile.vue?vue&type=script&lang=js"
import style0 from "./NewFile.vue?vue&type=style&index=0&id=7299799e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7299799e",
  null
  
)

export default component.exports